import { Component, OnInit } from '@angular/core';
import emailMask from 'text-mask-addons/dist/emailMask';
import { Router, ActivatedRoute } from '@angular/router'
import { SentemailService } from 'src/app/services/sentemail.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-calculate-step3',
  templateUrl: './calculate-step3.component.html',
  styleUrls: ['./calculate-step3.component.scss']
})
export class CalculateStep3Component implements OnInit {
  language = JSON.parse(localStorage.getItem('language'))
  emailPattern = emailMask
  emailPatternCheck = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  fName: string
  lName: string
  tel: string
  email: string

  fNameRequire: boolean = false
  telRequire: boolean = false
  telInvalidPattern: boolean = false

  sentEmailComplete: Boolean = false

  constructor(private router: Router, private _sentemailService: SentemailService, private loader: NgxUiLoaderService) { }

  ngOnInit() {
  }

  submit() {

    if (this.fName == undefined || this.fName == '') {
      this.fNameRequire = true
    } else {
      this.fNameRequire = false
    }

    if (this.tel == undefined || this.tel == '') {
      this.telRequire = true
    } else if (this.tel != undefined) {
      this.telRequire = false

    }

    if (this.email == undefined) {
      this.email = ''
    }

    if (!this.fNameRequire && !this.telRequire) {
      this.loader.start()
      this._sentemailService.setEmail('ขอรับการแนะนำการวางแผนการลงทุน', this.fName, this.tel, this.email, '').subscribe(response => {
        this.sentEmailComplete = true
        this.loader.stop()
      })

    }
  }


}
